class StoreZone {
  /**
   * API and some store paths may expose `points` / `corridorPoints` as JSON strings.
   * Map and form code require number[][]; coerce here and in FromJSON / FromNormalizedRESTModel.
   */
  static parsePointsArray (value) {
    if (value == null || value === '') return null
    if (Array.isArray(value)) return value
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : null
      } catch {
        return null
      }
    }
    return null
  }

  constructor (
    id = undefined,
    name,
    warningMessage,
    description,
    typeId,
    shapeTypeId,
    centerLatitude,
    centerLongitude,
    radius,
    points,
    corridorWidth,
    corridorPoints,
    active,
    enabled = undefined,
    isActive = undefined,
    isDeleted = undefined,
    userId = undefined,
    ownerFamilyId = undefined,
    createdAt,
    mobileDeviceCount = 0,
    trackerDeviceCount = 0
  ) {
    this.id = id
    this.userId = userId
    this.ownerFamilyId = ownerFamilyId
    this.name = name
    this.warningMessage = warningMessage
    this.description = description
    this.typeId = typeId
    this.type = null
    this.shapeTypeId = shapeTypeId
    this.shapeType = null
    this.centerLatitude = centerLatitude
    this.centerLongitude = centerLongitude
    this.radius = radius
    this.points = points
    this.corridorWidth = corridorWidth
    this.corridorPoints = corridorPoints
    const resolvedActive = active ?? enabled ?? isActive
    this.active = resolvedActive
    this.isActive = isActive ?? resolvedActive
    this.isDeleted = isDeleted === true
    this.createdAt = new Date(createdAt)
    this.mobileDeviceCount = mobileDeviceCount ?? 0
    this.trackerDeviceCount = trackerDeviceCount ?? 0
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      name: this.name,
      warningMessage: this.warningMessage,
      description: this.description,
      typeId: this.typeId,
      shapeTypeId: this.shapeTypeId,
      centerLatitude: this.centerLatitude,
      centerLongitude: this.centerLongitude,
      radius: this.radius,
      points: this.points && JSON.stringify(this.points),
      corridorWidth: this.corridorWidth,
      corridorPoints: this.corridorPoints && JSON.stringify(this.corridorPoints),
      active: this.active
      // createdAt is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name,
    warningMessage,
    description,
    typeId,
    shapeTypeId,
    centerLatitude,
    centerLongitude,
    radius,
    points,
    corridorWidth,
    corridorPoints,
    active,
    enabled,
    isActive,
    isDeleted,
    userId,
    ownerFamilyId,
    createdAt,
    mobileDeviceCount,
    trackerDeviceCount
  }) {
    return new StoreZone(
      id,
      name,
      warningMessage,
      description,
      typeId,
      shapeTypeId,
      centerLatitude,
      centerLongitude,
      radius,
      StoreZone.parsePointsArray(points),
      corridorWidth,
      StoreZone.parsePointsArray(corridorPoints),
      active,
      enabled,
      isActive,
      isDeleted,
      userId,
      ownerFamilyId,
      createdAt,
      mobileDeviceCount,
      trackerDeviceCount
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name,
      warningMessage: this.warningMessage,
      description: this.description,
      typeId: this.typeId,
      shapeTypeId: this.shapeTypeId,
      centerLatitude: this.centerLatitude,
      centerLongitude: this.centerLongitude,
      radius: this.radius,
      points: this.points,
      corridorWidth: this.corridorWidth,
      corridorPoints: this.corridorPoints,
      active: this.active,
      isActive: this.isActive,
      isDeleted: this.isDeleted,
      userId: this.userId,
      ownerFamilyId: this.ownerFamilyId,
      createdAt: this.createdAt,
      mobileDeviceCount: this.mobileDeviceCount,
      trackerDeviceCount: this.trackerDeviceCount
    }
  }

  static FromJSON ({
    id,
    name,
    warningMessage,
    description,
    typeId,
    shapeTypeId,
    centerLatitude,
    centerLongitude,
    radius,
    points,
    corridorWidth,
    corridorPoints,
    active,
    enabled,
    isActive,
    isDeleted,
    userId,
    ownerFamilyId,
    createdAt,
    mobileDeviceCount,
    trackerDeviceCount
  }) {
    return new StoreZone(
      id,
      name,
      warningMessage,
      description,
      typeId,
      shapeTypeId,
      centerLatitude,
      centerLongitude,
      radius,
      StoreZone.parsePointsArray(points),
      corridorWidth,
      StoreZone.parsePointsArray(corridorPoints),
      active,
      enabled,
      isActive,
      isDeleted,
      userId,
      ownerFamilyId,
      createdAt,
      mobileDeviceCount,
      trackerDeviceCount
    )
  }
}

export default StoreZone
